module.exports = __webpack_public_path__ + "static/img/successBg.7a827ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/successBg.png
// module id = gUVU
// module chunks = 1